import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";

import "../../styles/Footer/Footer.scss";

const Footer = ({ darkTheme }) => {
  return (
    <>
      <div
        className={`footer ${darkTheme ? "dark" : "light"}`}
        style={{
          backgroundColor: darkTheme ? "black" : "white",
          fontWeight: darkTheme ? "none" : 600,
        }}
      >
        <div
          className="footer__container"
          style={{
            color: darkTheme ? "white" : "black",
          }}
        >
          <p>
            Made with <FontAwesomeIcon icon={faHeart} size="sm" /> by Mohd.
            Aquib
          </p>
        </div>
      </div>
    </>
  );
};

export default Footer;
